import React from 'react';

export const LibraryLayout: React.FC = ({children}) => {
  return <div style={{width: '100vw'}}>{children}</div>;
};
